import React from "react";
import { NavLink } from "react-router-dom";
import "./Searchnav.css";
import WelcomeName from "./WelcomeName";
function Searchnav() {
    return (
        <>
            <div class="searchnav-container">
                <div class="searchnav-wrap">
                    <div class="searchnav-row">
                        <div class="searchnav-box">
                            <img src={process.env.PUBLIC_URL + "/images/Acc_Logo_Black_Purple_RGB.png"} className="acc-logo" alt="logo" />
                            <p class="desktop-tag">
                                <span>Learning & Talent Transformation</span> <br />{" "}
                                <p className="desktop-tag-1" style={{ color: "#0041F0" }}>
                                    Enbridge Talent Academy
                                </p>
                            </p>
                            <p class="mobile-tag">
                                <span>L&TT</span> <br />{" "}
                                <p className="mobile-tag-1" style={{ color: "#0041F0" }}>
                                    ETA
                                </p>
                            </p>
                            <NavLink to="/home">
                                <img src={process.env.PUBLIC_URL + "/images/Home/home-icon-blue.png"} className="home-icon" alt="homeicon" />
                            </NavLink>
                        </div>
                    </div>
                    <div class="searchnav-row">
                        <div class="searchnav-box" style={{ textAlign: "right", marginTop: "10px" }}>
                            {/* <p>Hello {localStorage.getItem("empName")}!</p> */}
                            {/* <p>Hello !</p> */}
                            <WelcomeName />
                            <img src={process.env.PUBLIC_URL + "/images/Avatar.png"} className="user-img" alt="user-image" />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Searchnav;
